import conf from "./config";
import _vm from '@/main'
import axios from 'axios';

const slowMode = false;

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'AppBase': conf.appBaseUrl
};

const con = axios.create({
    baseURL: conf.apiBaseUrl,
    headers: headers,
    withCredentials: true
});

con.interceptors.request.use(async function (config) {
    if(slowMode){
        console.log("Slow mod açık")
        let ms = Math.floor(Math.random() * 5)
        await _vm.$fnc.delay(Number((ms === 0 ? 1 :ms)+"000"));
    }
    if(localStorage.getItem('gToken')){
        config.headers.Authorization = localStorage.getItem('gToken');
    }
    return config;
});
con.interceptors.response.use(
    response => {
        let v = response.headers['app-ver'] || 'default'
        if(v !== localStorage.getItem('AppVer') && response.config.method === 'get'){
            localStorage.setItem('AppVer', v)
            window.location.reload();
        }
        //#####################
        if(typeof response.data === 'object'){
            if(!response.data.success){
                if(response.data.msgCode === 101){
                    window.location.href = conf.appBaseUrl+"repair.html";
                }
            }
            return Promise.resolve(response.data);
        }else{
            _vm.$fnc.toastError("Sunucu hatası !")
            return Promise.reject(response.data);
        }

    },
    error => {
        if(error.response && error.response.data.message){
            _vm.$fnc.toastError(error.response.data.message ?? error.message, "Hata")
        }else{
            _vm.$fnc.toastError(error.message)
        }
        if(error.response.status === 401){
            _vm.$store.dispatch('auth/logout',error.response.data.message).then(()=>{
                _vm.$router.push({name:"HomePage"});
            });
        }
        return Promise.reject(error);
    });

export function queryString(params){
    return "?"+Object.keys(params).map(key => { return ( encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) ) }).join('&');
}


export default con;
